import axios from "axios";

//IMPORT API ROUTE URL
import { UPDATE_SELF_SERVICE_ROUTE } from "./apiRoutes";

const updateSelfService = (userSlug, resourceSlug) => {
  var postData = new FormData();

  postData.append("user_slug", userSlug);
  postData.append("resource_slug", resourceSlug);

  return axios
    .post(UPDATE_SELF_SERVICE_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default updateSelfService;
